goog.provide('el8.appchart.providers.main');

goog.require('el8.app.pageLayout');
goog.require('el8.app.shared.network.viewEditConnection');
goog.require('el8.appchart.dialog.referralHistory');
goog.require('el8.appchart.mainFeeds.chart');
goog.require('el8.appchart.mainFeeds.plrNotification');
goog.require('el8.appchart.mgr.thirdpane');
goog.require('el8.appchart.providers.search');
goog.require('el8.appchart.providers.tooltips');
goog.require('el8.appshared.dialog.epnSearchPrompt');
goog.require('el8.appshared.mindreaderOpts');
goog.require('el8.data.specialtyCategories');
goog.require('el8.model.base');
goog.require('el8.ptdata.plrCollaborators');
goog.require('el8.ptdata.ptProviders');
goog.require('el8.ptdata.careTeamProviders');

goog.require('el8.service.urls');
goog.require('el8.template.appchart.providers');
goog.require('el8.uiwidget.ClickText');
goog.require('el8.uiwidget.deleteConfirm');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.TabbedNav');
goog.require('el8.util.consts');


/**
 * This file manages the Providers List fourth pane
 */
el8.appchart.providers.main = (function() {

    var that = {};

    var container = $('#fourth-pane');
    var $content = null;

    var tabbedNav = null;
    var actionsMenu = null;
    var clickTexts = {};

    var teamTabIsInit = false; // represents whether the team tab has had postRenderFn called on it yet

    $.extend(that, {

        toggle: function() {
            if (that.isOpen()) {
                that.hide();
            } else {
                that.show();
            }
        },

        show: function(spec) {
            spec = spec || {};

            // don't want EPN showing for test accounts - in case we left the flag on
            // but PASSPORT_EMR accounts are OK
            if (!el8Globals.PASSPORT_EMR && !el8.data.currUser.isPracticeAuthenticated()) {
                UIM && UIM.logError('Test account opening EPN');
                return;
            }

            if (that.isOpen()) {
                // might still want to switch tabs
                if (spec.tab === 'team') {
                    that.showTab('team');
                } else if (spec.searchString) {
                    $(':input[name="filterSpecialty"]', $content).val(spec.searchString);
                    el8.appchart.providers.search.doFilter({name: spec.searchString});
                }
                return;
            }

            /* Synchronously load entity sets if not already loaded */
            el8.data.specialtyCategories.softLoad();
            el8.ptdata.ptProviders.softLoad();
            if (el8Globals.FEATURES.PLR4Everyone) {
                el8.ptdata.careTeamProviders.softLoad();
            }

            $('#providers_trigger').addClass('el8PLOpen');

            var templateDict = el8.ptdata.ptProviders.sortedByGroup({ indicatePracticeUsers: true });
            templateDict.specialtyCategories = el8.data.specialtyCategories.allAsSoyMaps();
            templateDict.collaboratorPractices = el8.ptdata.plrCollaborators.getPracticeIds();

            if (el8Globals.FEATURES.PLR4Everyone) {
                templateDict.careTeamProviders = el8.ptdata.careTeamProviders.sortedByGroup({ indicatePracticeUsers: true, indicateCurrentUser: true });
                templateDict.careTeamWithMainProviders = templateDict.careTeamProviders.activeMembers.concat(templateDict.careTeamProviders.invitations).concat(templateDict.mainProviders);
                templateDict.inactiveCareTeamWithOtherProviders = templateDict.careTeamProviders.inactiveMembers.concat(templateDict.otherProviders);

                var physician_ids = [];
                templateDict.careTeamWithMainProviders =
                _.filter(templateDict.careTeamWithMainProviders, function(p) {
                    if (!p['physicianId']) { return true; }
                    if (physician_ids.indexOf(p['physicianId']) === -1) {
                        physician_ids.push(p['physicianId']);
                        return true;
                    } else {
                        return false;
                    }
                });
                templateDict.inactiveCareTeamWithOtherProviders =
                _.filter(templateDict.inactiveCareTeamWithOtherProviders, function(p) {
                    if (!p['physicianId']) { return true; }
                    if (physician_ids.indexOf(p['physicianId']) === -1) {
                        physician_ids.push(p['physicianId']);
                        return true;
                    } else {
                        return false;
                    }
                });

                templateDict.careTeamWithMainProviders.sort(that.careTeamSortFn);
                templateDict.inactiveCareTeamWithOtherProviders.sort(that.careTeamSortFn);
            }


            templateDict.currentUser = el8.data.currUser.asSoyMap();
            templateDict.currentPractice = el8.data.currPractice.asSoyMap();
            container.html(el8.template.appchart.providers.content(templateDict));
            $content = $('.provider-list-container', container);
            setupTabbedNav();
            bindTriggers();
            initializeInputFields();

            if (el8Globals.FEATURES.PLR4Everyone) {
                if (templateDict.careTeamProviders.activeMembers.length +
                    templateDict.careTeamProviders.inactiveMembers.length < 2) {
                    $('.care-team-no-member-prompt', container).show();
                } else {
                    $('.care-team-no-member-prompt', container).hide();
                }
            }

            el8.appchart.layout.showFourthPane(function() {
                clickTexts = {};

                if (spec.tab === 'team') {
                    that.showTab('team');
                } else if (spec.searchString) {
                    $(':input[name="filterSpecialty"]', $content).val(spec.searchString);
                    el8.appchart.providers.search.doFilter({name: spec.searchString});
                } else {
                    $(':input[name="filterSpecialty"]', $content).focusFocus();
                }
            });

            el8.ptdata.ptProviders.bind(EVENTS.LOADED, triggerRefreshFn);
            el8.ptdata.ptProviders.bind('MOVED_MAIN', triggerRefreshFn);
            el8.ptdata.ptProviders.bind(EVENTS.UPDATED, refreshProvider);
            if (el8Globals.FEATURES.PLR4Everyone) {
                el8.ptdata.careTeamProviders.bind(EVENTS.LOADED, triggerRefreshFn);
                el8.ptdata.careTeamProviders.bind(EVENTS.UPDATED, refreshProvider);
            }
        },

        hide: function() {
            destroyTooltips($content);
            el8.appchart.layout.hideFourthPane(function() {
                el8.appchart.providers.search.resetVars();
                container.empty();
            });
            $content = null;
            tabbedNav = null;
            teamTabIsInit = false;
            actionsMenu = null;
            that._mindreader = null;
            clickTexts = {};

            $('#providers_trigger').removeClass('el8PLOpen').blur();

            /* Unbind relevant listeners */
            el8.ptdata.ptProviders.unbind(EVENTS.LOADED, triggerRefreshFn);
            el8.ptdata.ptProviders.unbind('MOVED_MAIN', triggerRefreshFn);
            el8.ptdata.ptProviders.unbind(EVENTS.UPDATED, refreshProvider);
            if (el8Globals.FEATURES.PLR4Everyone) {
                el8.ptdata.careTeamProviders.bind(EVENTS.LOADED, triggerRefreshFn);
                el8.ptdata.careTeamProviders.bind(EVENTS.UPDATED, refreshProvider);
            }
        },

        getShowingTab: function() {
            if (!that.isOpen()) { return null; }
            return tabbedNav.getShowingTab();
        },
        showTab: function(name) {
            if (!that.isOpen()) { return false; }
            if (that.getShowingTab() === name) { return true; }

            tabbedNav.showTab(name);
            return true;
        },

        // search/doFilter needs access to these functions,
        // but they should otherwise be considered internal
        _postRenderFn: postRenderFn,
        _destroyTooltips: destroyTooltips,

        isOpen: function() {
            return ($content && $content.is(':visible'));
        }

    });


    /**
     * Helper functions for pane initialization */
    function setupTabbedNav() {
        tabbedNav = new el8.uiwidget.TabbedNav();
        tabbedNav.init({
            wrapper: $('.tabbed-nav', container), // tabbed nav is outside $content
            tabSectionClass: 'el8ProviderTabSection',
            tabItemClass: 'el8ProviderTab'
        });

        tabbedNav.addTab({
            title: "Patient's Providers",
            name: 'team',
            contentDiv: $('.provider-list-section', $content),
            showTabFn: function() {
                if (!teamTabIsInit) {
                    /* Call postRenderFn on this tab the first time we render it
                     * (search tab will take care of itself after searching).
                     *
                     * We can't do this in the showFourthPane callback, b/c if the team tab isn't
                     * actually showing yet, 'treating' text heights will be all messed up */
                    postRenderFn($('.provider-list-section', $content));
                    teamTabIsInit = true;
                }
            }
        });
        tabbedNav.addTab({
            title: 'Provider Search',
            name: 'search',
            contentDiv: $('.provider-search-section', $content),
            showTabFn: function() {
                $(':input[name="filterSpecialty"]', $content).focusFocus();
            }
        });
        tabbedNav.addTab({
            title: 'X',
            name: 'close',
            additionalClass: 'el8ProviderTabCloseButton',
            showTabFn: function() {
                el8.appchart.providers.main.hide();
            }
        });
        tabbedNav.showTab('team');
    }

    function bindTriggers() {
        $content.on('click', '.fetch-connections-trigger',  _.debounce(function() {
            var id = $(this).data('id');
            el8.appchart.providers.search.doFilter({categoryId: id, isAuto: true});
            return false;
        }, el8.util.consts.DOUBLE_CLICK_RATE, true));

        $content.on('click', '.provider-add-treating-trigger',  _.debounce(function() {
            var $providerEntry = $(this).closest('.provider-entry');
            var id = $providerEntry.data('id');
            // don't need to find $providerEntry or move the scroll position, so we don't use focusTreatmentReason
            if (!clickTexts[id]) { addInitTreatmentReasonField(id, $providerEntry); }
            clickTexts[id].setFocus();
        }, el8.util.consts.DOUBLE_CLICK_RATE, true));

        $content.on('click', '.provider-write-message-trigger',  _.debounce(function() {
            var id = $(this).closest('.provider-entry').data('id');
            var provider = el8.ptdata.ptProviders.getById(id);
            if (provider.getPhysician() && provider.getPhysician().getAccessUserId()) {
                el8.appshared.message.prePopulateNewMessage({
                    toUsers: [el8.data.practiceUsers.getById(provider.getPhysician().getAccessUserId())]
                });
            }
            that.hide();
        }, el8.util.consts.DOUBLE_CLICK_RATE, true));

        $content.on('click', '.provider-write-referral-trigger',  _.debounce(function() {
            var id = $(this).closest('.provider-entry').data('id');
            var provider = el8.ptdata.ptProviders.getById(id);

            el8.appchart.mgr.thirdpane.setReferralLetterContact(provider.getPhysicianId(), 'patient-provider-directory');
            that.hide();
        }, el8.util.consts.DOUBLE_CLICK_RATE, true));

        $content.on('click', '.provider-write-letter-trigger',  _.debounce(function() {
            var id = $(this).closest('.provider-entry').data('id');
            var provider = el8.ptdata.ptProviders.getById(id);
            that.hide();
            el8.appchart.mgr.thirdpane.setLetterContact(provider.getPhysicianId(), 'patient-provider-directory');
        }, el8.util.consts.DOUBLE_CLICK_RATE, true));

        $content.on('click', '.provider-name-trigger',  _.debounce(function() {
            var id = $(this).closest('.provider-entry').data('id');
            var provider = el8.ptdata.ptProviders.getById(id);
            var contactId = $(this).data('id');
            el8.app.shared.network.viewEditConnection.show({
                contactId: contactId,
                callbackFn: function(connection) {
                    if (contactId !== connection.getId()) {
                        provider.updatePhysicianId(contactId);
                    }
                    // will be re-rendered by reload of ptProviders set in saveFn
                }
            });
        }, el8.util.consts.DOUBLE_CLICK_RATE, true));

        // same set of links, but for care team entries
        $content.on('click', '.care-team-add-treating-trigger',  _.debounce(function() {
            var $careTeamEntry = $(this).closest('.care-team-entry');
            var id = $careTeamEntry.data('id');
            // don't need to find $careTeamEntry or move the scroll position, so we don't use focusTreatmentReason
            if (!clickTexts[id]) { addInitCareTeamNotesField(id, $careTeamEntry); }
            clickTexts[id].setFocus();
        }, el8.util.consts.DOUBLE_CLICK_RATE, true));

        $content.on('click', '.care-team-write-message-trigger',  _.debounce(function() {
            var id = $(this).closest('.care-team-entry').data('id');
            var provider = el8.ptdata.careTeamProviders.getById(id);
            if (provider.getPhysician() && provider.getPhysician().getAccessUserId()) {
                el8.appshared.message.prePopulateNewMessage({
                    toUsers: [el8.data.practiceUsers.getById(provider.getPhysician().getAccessUserId())]
                });
            }
            that.hide();
        }, el8.util.consts.DOUBLE_CLICK_RATE, true));

        $content.on('click', '.care-team-write-referral-trigger',  _.debounce(function() {
            var id = $(this).closest('.care-team-entry').data('id');
            var provider = el8.ptdata.careTeamProviders.getById(id);

            el8.appchart.mgr.thirdpane.setReferralLetterContact(provider.getPhysicianId(), 'care-team');
            that.hide();
        }, el8.util.consts.DOUBLE_CLICK_RATE, true));

        $content.on('click', '.care-team-write-letter-trigger',  _.debounce(function() {
            var id = $(this).closest('.care-team-entry').data('id');
            var provider = el8.ptdata.careTeamProviders.getById(id);
            that.hide();
            el8.appchart.mgr.thirdpane.setLetterContact(provider.getPhysicianId(), 'care-team');
        }, el8.util.consts.DOUBLE_CLICK_RATE, true));

        $content.on('click', '.care-team-name-trigger',  _.debounce(function() {
            var id = $(this).closest('.care-team-entry').data('id');
            var provider = el8.ptdata.careTeamProviders.getById(id);
            var contactId = $(this).data('id');
            el8.app.shared.network.viewEditConnection.show({
                contactId: contactId,
                callbackFn: function(connection) {
                    if (contactId !== connection.getId()) {
                        provider.updatePhysicianId(contactId);
                    }
                    // will be re-rendered by reload of ptProviders set in saveFn
                }
            });
        }, el8.util.consts.DOUBLE_CLICK_RATE, true));

        $content.on('click', '.clear-filter-trigger',  function() {
            el8.appchart.providers.search.resetRender();
            $('.reveal-post-search', $content).hide();
        });

        $content.on('click', '.do-filter-trigger',  function() {
            var val = $(':input[name="filterSpecialty"]', $content).val();
            if (val) {
                var id = el8.data.specialtyCategories.getIdByName(val);
                if (id) {
                    el8.appchart.providers.search.doFilter({categoryId: id});
                } else {
                    el8.appchart.providers.search.doFilter({name: val});
                }
            } else {
                el8.appchart.providers.search.resetRender();
            }
        });

        $content.on('click', '.toggle-care-event-history',  function() {
            var $careHistoryElt = $(this).closest('.provider-entry').find('.care-event-history');
            if ($careHistoryElt.is(':visible')) {
                $(this).text('Details');
                $careHistoryElt.hide();
            } else {
                $(this).text('Hide');
                $careHistoryElt.show();
            }
        });

        $content.on('click', '.provider-action-button',  function() {
            var id = $(this).closest('.provider-entry').data('id');
            var member = el8.ptdata.ptProviders.getById(id);
            var menu = that.getProviderActionMenu(member);

            if (!actionsMenu) {
                actionsMenu = new el8.uiwidget.NewActionsMenu({
                    container: $content,
                    menuId: 'provider-pane-menu',
                    width: 200
                });
            }
            var $anchorTop = (tabbedNav.getShowingTab() === 'team') ?
                $('.provider-list-section', $content) : $('.provider-search-section', $content);
            actionsMenu.setAnchorTop($anchorTop);
            actionsMenu.display($(this), null, {top: 15, left: -5}, menu);

            return false;
        });

        $content.on('click', '.care-team-action-button',  function() {
            var id = $(this).closest('.care-team-entry').data('id');
            var member = el8.ptdata.careTeamProviders.getById(id);
            var menu = that.getCareTeamMemberActionMenu(member);

            if (!actionsMenu) {
                actionsMenu = new el8.uiwidget.NewActionsMenu({
                    container: $content,
                    menuId: 'provider-pane-menu',
                    width: 200
                });
            }
            var $anchorTop = (tabbedNav.getShowingTab() === 'team') ?
                $('.provider-list-section', $content) : $('.provider-search-section', $content);
            actionsMenu.setAnchorTop($anchorTop);
            actionsMenu.display($(this), null, {top: 15, left: -5}, menu);

            return false;
        });

        // pretty sure this isn't being used, will find out if we have an amplitude event from it
        $content.on('click', '.add-care-team-member-trigger',  function() {
            el8.appchart.mgr.thirdpane.showLetter({
                type: 'letter',
                autoAddToCareTeam: true,
                clickSource: 'add-care-team-member'
            });
        });

        $content.on('click', '.show-search-tab',  function() {
            that.showTab('search');
        });
    }

    that.careTeamSortFn = function(x,y) {
        // NOTE: maybe good to refactor down the road
        // this sorting will put people from myself first (on the top)
        // then put people from my practice first (next up on the top)
        var a = x.isCurrentUser ? '0' : '1';
        var b = y.isCurrentUser ? '0' : '1';
        a += x.isPracticeUser ? '0' : '1';
        b += y.isPracticeUser ? '0' : '1';
        a += x.physician.reverseName;
        b += y.physician.reverseName;

        if (a > b) { return 1; }
        else if (a < b) { return -1; }
        else { return 0; }
    };

    that.getCareTeamMemberActionMenu = function(member) {
        var menu = [];
        var is_able_to_grant_access = el8.ptdata.careTeamProviders.canCurrentUserGrantAccess();
        var is_you = (member.getPhysician().getUserId() === el8.data.currUser.getId());
        var is_sharing = member.isSharingEnabled();
        var is_active = member.isActive();
        var is_invite_pending = member.isInvitePending();
        var is_invited_by_me = member.isInvitedByMe();
        var is_inviting_me = member.isInvitingMe();

        if (is_you && is_able_to_grant_access) {
            if (el8.ptdata.careTeamProviders.all().length > 1 && is_active) {
                menu.push({
                    actionText: 'Leave Care Team',
                    actionFn: function() {
                        $.el8_ajax({
                            type: 'DELETE',
                            url: el8.service.urls.get('careTeamProvider', [member.getId()]),
                            success: function(data) {
                                el8.appservice.notifier.notify("You have removed yourself from this patient's Care Team.");
                                el8.ptdata.ptProviders.load();
                                el8.ptdata.careTeamProviders.load();
                                el8.appchart.providers.main.refreshPatientTeam();
                                el8.appchart.mainFeeds.plrNotification.refresh();
                                el8.appchart.mainFeeds.chart.update();
                            }
                        });
                        el8.util.amplitude.logCareActionForPLRClinics({action: CARE_TEAM_ACTIONS.leaveCareTeam, providerId: member.getPhysicianId(), source:"Care Team"});
                    }
                });
            }
            if (is_sharing) {
                menu.push({
                    actionText: 'Stop sharing my records',
                    actionFn: function() {
                        $.el8_ajax({
                            type: 'POST',
                            data: JSON.stringify({ sharing_enabled: false }),
                            url: el8.service.urls.get('setCareTeamSharing'),
                            success: function(data) {
                                el8.appservice.notifier.notify("You are no longer sharing records with this patient's Care Team.");
                                el8.ptdata.ptProviders.load();
                                el8.ptdata.careTeamProviders.load();
                                el8.appchart.providers.main.refreshPatientTeam();
                            }
                        });
                        el8.util.amplitude.logCareActionForPLRClinics({action: CARE_TEAM_ACTIONS.stopSharingRecords, providerId: member.getPhysicianId(), source:"Care Team"});
                    }
                });
            }
            else {
                menu.push({
                    actionText: 'Share my records',
                    actionFn: function() {
                        $.el8_ajax({
                            type: 'POST',
                            data: JSON.stringify({ sharing_enabled: true }),
                            url: el8.service.urls.get('setCareTeamSharing'),
                            success: function(data) {
                                el8.appservice.notifier.notify("You are now sharing records with this patient's Care Team.");
                                el8.ptdata.ptProviders.load();
                                el8.ptdata.careTeamProviders.load();
                                el8.appchart.providers.main.refreshPatientTeam();
                            }
                        });
                        el8.util.amplitude.logCareActionForPLRClinics({action: CARE_TEAM_ACTIONS.shareRecords, providerId: member.getPhysicianId(), source:"Care Team"});
                    }
                });
            }
        }

        // the main actions that frontend can take
        if (is_able_to_grant_access) {
            if (is_active) {
                // PLR users can delete any non-collaborators.
                // If PLR is off, we'll stop you from deleting anyone in your enterprise,
                // so that you don't remove people who are actually collaborators
                var deletingAllowed = false;
                if (member.getProviderLogo() === 'passport') {
                    deletingAllowed = true;
                }
                if (deletingAllowed) {
                    menu.push({
                        actionText: 'Remove from Care Team',
                        actionFn: function() {
                            $.el8_ajax({
                                type: 'DELETE',
                                url: el8.service.urls.get('careTeamProvider', [member.getId()]),
                                success: function(data) {
                                    el8.appservice.notifier.notify("You have removed a physician from this patient's Care Team.");
                                    el8.ptdata.ptProviders.load();
                                    el8.ptdata.careTeamProviders.load();
                                    el8.appchart.providers.main.refreshPatientTeam();
                                }
                            });
                            el8.util.amplitude.logCareActionForPLRClinics({action: CARE_TEAM_ACTIONS.removeFromCareTeam, providerId: member.getPhysicianId(), source:"Care Team"});
                        }
                    });
                }
            } else if (is_invite_pending) {
                if (is_invited_by_me) {
                    menu.push({
                        actionText: 'Cancel Invitation',
                        actionFn: function() {
                            $.el8_ajax({
                                type: 'DELETE',
                                url: el8.service.urls.get('careTeamInvitation', [member.getId()]),
                                success: function(data) {
                                    el8.appservice.notifier.notify("You have cancelled a request to collaborate with " + member.getInvitingPhysician().getFullName() + " on this patient's Care Team.");
                                    el8.ptdata.ptProviders.load();
                                    el8.ptdata.careTeamProviders.load();
                                    el8.appchart.providers.main.refreshPatientTeam();
                                }
                            });
                        }
                    });
                } else if (is_inviting_me) {
                    menu.push({
                        actionText: 'Accept Invitation',
                        actionFn: function() {
                            $.el8_ajax({
                                type: 'POST',
                                data: JSON.stringify({ action: 'accept' }),
                                url: el8.service.urls.get('careTeamInvitation', [member.getId()]),
                                success: function(data) {
                                    el8.appservice.notifier.notify("You are now collaborating with " + member.getInvitingPhysician().getFullName() + " on this patient's Care Team.");
                                    el8.ptdata.ptProviders.load();
                                    el8.ptdata.careTeamProviders.load();
                                    el8.appchart.providers.main.refreshPatientTeam();
                                }
                            });
                        }
                    });
                    menu.push({
                        actionText: 'Decline Invitation',
                        actionFn: function() {
                            $.el8_ajax({
                                type: 'POST',
                                data: JSON.stringify({ action: 'decline' }),
                                url: el8.service.urls.get('careTeamInvitation', [member.getId()]),
                                success: function(data) {
                                    el8.appservice.notifier.notify("You have declined to collaborate with " + member.getInvitingPhysician().getFullName() + " on this patient's Care Team.");
                                    el8.ptdata.ptProviders.load();
                                    el8.ptdata.careTeamProviders.load();
                                    el8.appchart.providers.main.refreshPatientTeam();
                                }
                            });
                        }
                    });
                }
            } else {
                // i can invite/grant access to an inactive care team member,
                // not that we really have those anymore... so this is kind of defunct
                menu.push({
                    actionText: 'Grant access to shared records', // this was the old "invite"
                    actionFn: function() {
                        el8.appchart.mgr.thirdpane.showLetter({
                            type: 'letter',
                            autoAddToCareTeam: true,
                            contactId: member.getPhysicianId(),
                            clickSource: 'grant-access-to-shared-records'
                        });
                    }
                });
            }
        }

        menu = menu.concat(getSharedActionMenu(member));
        return menu;
    };

    that.getProviderActionMenu = function(provider) {
        var id = provider.getId();
        var physician_id = provider.getPhysicianId();
        var menu = [];

        if (el8Globals.FEATURES.PLR4Everyone && el8.ptdata.careTeamProviders.canCurrentUserGrantAccess()) {
            if (provider.getPhysician().getCmsNpi()) {
                menu.push({
                    actionText: 'Grant access to shared records',
                    actionFn: function() {
                        el8.appchart.mgr.thirdpane.showLetter({
                            type: 'letter',
                            autoAddToCareTeam: true,
                            contactId: physician_id,
                            clickSource: 'care-team-action-menu'
                        });
                        el8.util.amplitude.logCareActionForPLRClinics({action: CARE_TEAM_ACTIONS.grantAccess, providerId: physician_id, source:"Care Team"});
                    }
                });
            } else {
                // allow for feature to associate scratch physician to a canonical
                menu.push({
                    actionText: 'Grant access to shared records',
                    actionFn: function() {
                        el8.appshared.dialog.epnSearchPrompt.show({
                            promptMessage: 'You can only grant access to shared records for known provider profiles. Try searching for this provider in Elation Provider Network.',
                            searchString: provider.getPhysician().getFirstName() + ' ' + provider.getPhysician().getLastName()
                        });
                        el8.util.amplitude.logCareActionForPLRClinics({action: CARE_TEAM_ACTIONS.grantAccess, providerId: physician_id, source:"Care Team"});
                    }
                });
            }
        }

        var textAddToProviderList = el8Globals.FEATURES.PLR4Everyone ? 'Add to Care Team' : 'Add to Provider List';
        var textRemoveFromProviderList = el8Globals.FEATURES.PLR4Everyone ? 'Remove from Care Team' : 'Remove from Provider List';

        if (provider.getGroup() === 'other') {
            // in PLR4Everyone, we don't want people to add stuff to provider list
            menu.push({
                actionText: textAddToProviderList,
                actionFn: function() {
                    el8.ptdata.ptProviders.moveToMainGroup(id);
                    el8.ptdata.ptProviders.saveRankOrder({
                        successCb: function() {
                            el8.appchart.providers.main.refreshPatientTeam();
                            el8.appchart.providers.search.onTeamRearrange();
                        }
                    });
                    el8.util.amplitude.logCareActionForPLRClinics({action: CARE_TEAM_ACTIONS.addToCareTeam, providerId: provider.getPhysicianId(), source:"Care Team"});
                }
            });
        } else {
            menu.push({
                actionText: textRemoveFromProviderList,
                actionFn: function() {
                    el8.ptdata.ptProviders.moveToOtherGroup(id);
                    el8.ptdata.ptProviders.saveRankOrder({
                        successCb: function() {
                            el8.appchart.providers.main.refreshPatientTeam();
                            el8.appchart.providers.search.onTeamRearrange();
                        }
                    });
                    el8.util.amplitude.logCareActionForPLRClinics({action: CARE_TEAM_ACTIONS.removeFromCareTeam, providerId: provider.getPhysicianId(), source:"Care Team"});
                }
            });
        }


        // PLR users can delete any non-collaborators. (note this is related to old PLR, not PLR4Everyone)
        // If PLR is off, we'll stop you from deleting anyone in your enterprise,
        // so that you don't remove people who are actually collaborators
        var deletingAllowed = true;
        if (el8Globals.FEATURES.PLR) {
            var collabPracticeIds = _.pluck(el8.ptdata.plrCollaborators.allAsSoyMaps(), 'practiceId');
            var isCollab = _(collabPracticeIds).contains(provider.getPhysician().getAccessPracticeId());
            deletingAllowed = !isCollab;
        } else {
            var coEnterpriseMembers = (el8.data.currPractice.getEnterpriseId() &&
                provider.getPhysician().getAccessEnterpriseId() === el8.data.currPractice.getEnterpriseId());
            deletingAllowed = !coEnterpriseMembers;
        }

        if (deletingAllowed) {
            menu.push({
                actionText: "Delete from Patient's Chart",
                actionFn: function() {
                    el8.uiwidget.deleteConfirm(
                        "provider",
                        function() {
                            el8.ptdata.ptProviders.deleteItem(id, false, {
                                successCb: triggerRefreshFn
                            });
                        },
                        null
                    );
                    el8.util.amplitude.logCareActionForPLRClinics({action: CARE_TEAM_ACTIONS.deleteFromChart, providerId: provider.getPhysicianId(), source:"Care Team"});
                }
            });
        }

        menu = menu.concat(getSharedActionMenu(provider));
        return menu;
    };

    function getSharedActionMenu(member) {
        var menu = [];
        var is_pcp = member.getPhysician().isPcp();
        var is_you = (member.getPhysician().getUserId() === el8.data.currUser.getId());

        // this section is for PCP
        // When this function is used, "this" is binded to the member variable
        var markAsPcpFunc = function() {
            var that = this;
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('patientProvidersPcp', [that.getPhysician().getId()]),
                success: function(data) {
                    el8.ptdata.currPatient.populate(data);
                    el8.appchart.refpanel.demog.triggerRender();
                    el8.ptdata.patients.trigger(EVENTS.UPDATED, el8.ptdata.currPatient);

                    el8.appservice.notifier.notify("You have marked " + that.getPhysician().getFullName() + " as the patient's PCP.");
                    el8.ptdata.ptProviders.trigger(EVENTS.LOADED);
                    el8.appchart.providers.main.refreshPatientTeam();
                }
            });
            el8.util.amplitude.logCareActionForPLRClinics({action: CARE_TEAM_ACTIONS.markAsPCP, providerId: that.getPhysicianId(), source:"Care Team"});
        };

        if (!is_pcp) {
            if (member.getPhysician().getCmsNpi()) {
                menu.push({
                    actionText: "Mark as Patient's PCP",
                    actionFn: _.bind(markAsPcpFunc, member)
                });
            } else {
                menu.push({
                    actionText: "Mark as Patient's PCP",
                    actionFn: function() {
                        el8.appshared.dialog.epnSearchPrompt.show({
                            promptMessage: "You can only mark known provider profiles as a Patient's Primary Care Provider. Try searching for this provider in Elation Provider Network.",
                            searchString: member.getPhysician().getFirstName() + ' ' + member.getPhysician().getLastName()
                        });
                        el8.util.amplitude.logCareActionForPLRClinics({action: CARE_TEAM_ACTIONS.markAsPCP, providerId: member.getPhysicianId(), source:"Care Team"});
                    }
                });
            }
        } else {
            menu.push({
                actionText: "Remove as Patient's PCP",
                actionFn: function() {
                    $.el8_ajax({
                        type: 'DELETE',
                        url: el8.service.urls.get('patientProvidersPcp', [member.getPhysician().getId()]),
                        success: function(data) {
                            el8.ptdata.currPatient.populate(data);
                            el8.ptdata.patients.trigger(EVENTS.UPDATED, el8.ptdata.currPatient);

                            el8.appservice.notifier.notify("You have removed " + member.getPhysician().getFullName() + " as the patient's PCP.");
                            el8.ptdata.ptProviders.trigger(EVENTS.LOADED);
                            el8.appchart.providers.main.refreshPatientTeam();
                        }
                    });
                    el8.util.amplitude.logCareActionForPLRClinics({action: CARE_TEAM_ACTIONS.removeAsPCP, providerId:member.getPhysicianId(), source:"Care Team"});
                }
            });
        }

        if (!is_you) {
            menu.push({
                actionText: 'Write Referral',
                actionFn: function() {
                    el8.appchart.mgr.thirdpane.showLetter({
                        type: el8.util.consts.REFERRAL_LETTER,
                        contactId: member.getPhysicianId(),
                        clickSource: 'provider-team-action'
                    });
                    el8.util.amplitude.logCareActionForPLRClinics({action: CARE_TEAM_ACTIONS.writeReferral, providerId: member.getPhysicianId(), source:"Care Team"});
                }
            });
            menu.push({
                actionText: 'Write Letter',
                actionFn: function() {
                    el8.appchart.mgr.thirdpane.showLetter({
                        type: el8.util.consts.CONSULTANT_LETTER,
                        contactId: member.getPhysicianId(),
                        clickSource: 'provider-team-action'
                    });
                    el8.util.amplitude.logCareActionForPLRClinics({action: CARE_TEAM_ACTIONS.writeLetter, providerId: member.getPhysicianId(), source:"Care Team"});
                }
            });
        }

        return menu;
    }

    function initializeInputFields() {
        that._mindreader = (new el8.uiwidget.NewMindreader({
            data: el8.data.specialtyCategories.all().map(function(a) { return a.getName(); }),
            minQueryLength: 1,
            containerWidth: 350,
            containerLeftOffset: -86,
            selectFn: function(e, item) {
                el8.appchart.providers.search.doFilter({categoryId: el8.data.specialtyCategories.getIdByName(item)});
            },
            actionsFirst: true,
            actions: [
                {
                    name: 'Search for providers with this name...',
                    actionFn: function(val) {
                        el8.appchart.providers.search.doFilter({name: val});
                    },
                    preserveValOnClick: true // don't clear the input after clicking
                }
            ],
            modifyRenderCb: function(params) {
                // instead of an infoDiv, we want to display the search string as the first action
                // (search for a provider named...); we also want a header before the results,
                // even though there is only one section of results
                if (params.infoDiv.is(':visible')) {
                    params.actionsDiv.prepend(el8.template.appchart.providers.providerMrHeader());
                    params.infoDiv.hide();
                }
                var actionText = (params.searchString) ? '"' + params.searchString + '"' : '(type a name)';
                $('.mr-action-item', params.actionsDiv).first().text(actionText);
                if (params.numMatches) {
                    params.mrSections[0].prepend(el8.template.appchart.providers.specialtyMrHeader());
                }
            }
        })).init($(':input[name="filterSpecialty"]', $content));

        var filterChangeFn = function() {
            updateFilterSummary();
            el8.appchart.providers.search.refreshContents();
        };
        $content.on('change', ':input[name="state"]',  filterChangeFn);
        $content.on('change', ':input[name="city"]',  filterChangeFn);

        var $collapsibleTrigger = $('.filter-collapse-trigger', $content);
        el8.uiwidget.collapsible({
            container: $('.filter-collapsible-section', $content),
            triggerElt: $collapsibleTrigger,
            statusElt: $collapsibleTrigger,
            statusTextCollapse: 'edit',
            statusTextExpand: 'hide',
            isCollapsed: false
        });

        $(':input[name="state"]', $content).val(el8.data.currPractice.getState() || 'CA');
        updateFilterSummary();
    }

    // this triggers a full refresh of the search tab; we avoid using it when we know only the local
    // results there may have changed and call onTeamRearrange instead
    function triggerRefreshFn() {
         // refresh tab 1:
        el8.appchart.providers.main.refreshPatientTeam();
         // and tab 2:
        el8.appchart.providers.search.refreshContents();
    }
    /* End Intialization Functions */


    /**
     * Helper functions for supporting display of providers
     */
    // Run this after re-rendering any section to do JS-based rendering initialization
    function postRenderFn($section) {
        // init treatment reason fields
        $('.provider-entry-treating-field', $section).each(function(index, elt) {
            var id = $(elt).data('id');
            var provider = el8.ptdata.ptProviders.getById(id);
            clickTexts[id] = initTreatmentReasonField($(elt), provider);
        });
        $('.care-team-entry-note-field', $section).each(function(index, elt) {
            var id = $(elt).data('id');
            var provider = el8.ptdata.careTeamProviders.getById(id);
            clickTexts[id] = initCareTeamNoteField($(elt), provider);
        });

        // hide the gear button if it's "myself" and im not in a paid practice or not a staff
        $('.care-team-action-button', $section).each(function(index, elt) {
            var id = $(this).closest('.care-team-entry').data('id');
            var member = el8.ptdata.careTeamProviders.getById(id);
            if (member.getPhysician().getUserId() === el8.data.currUser.getId() &&
                !el8.ptdata.careTeamProviders.canCurrentUserGrantAccess()) {
                $(elt).hide();
            }
        });
        el8.appchart.providers.tooltips.create($section);
    }
    /* If you're calling postRenderFn, you're creating tooltips and should call this
     * fn to delete them at some point. This wrapper around providers.tooltips exists
     * so that if the fn ever expands, search.js will gain access to the changes too */
    function destroyTooltips($section) {
        el8.appchart.providers.tooltips.destroy($section);
    }

    function updateFilterSummary() {
        var city = $(':input[name="city"]', $content).val();
        var state = $(':input[name="state"]', $content).val();
        $('.filter-summary', $content).html(
            el8.template.appchart.providers.filterSummary({city: city, state: (state ? state.toUpperCase() : '')})
        );
    }

    that.refreshPatientTeam = function() {
        var $patientTeam = $('.provider-list-section', $content);
        var sortedProvidersDict = el8.ptdata.ptProviders.sortedByGroup({ indicatePracticeUsers: true });
        sortedProvidersDict.collaboratorPractices = el8.ptdata.plrCollaborators.getPracticeIds();

        if (el8Globals.FEATURES.PLR4Everyone) {
            // TODO: refactor this with el8.appchart.providers.main.show()
            sortedProvidersDict.currentUser = el8.data.currUser.asSoyMap();
            sortedProvidersDict.currentPractice = el8.data.currPractice.asSoyMap();

            sortedProvidersDict.careTeamProviders = el8.ptdata.careTeamProviders.sortedByGroup({ indicatePracticeUsers: true, indicateCurrentUser: true });
            sortedProvidersDict.careTeamWithMainProviders = sortedProvidersDict.careTeamProviders.activeMembers.concat(sortedProvidersDict.mainProviders);
            sortedProvidersDict.inactiveCareTeamWithOtherProviders = sortedProvidersDict.careTeamProviders.inactiveMembers.concat(sortedProvidersDict.otherProviders);

            var physician_ids = [];
            sortedProvidersDict.careTeamWithMainProviders =
            _.filter(sortedProvidersDict.careTeamWithMainProviders, function(p) {
                if (!p['physicianId']) { return true; }
                if (physician_ids.indexOf(p['physicianId']) === -1) {
                    physician_ids.push(p['physicianId']);
                    return true;
                } else {
                    return false;
                }
            });
            sortedProvidersDict.inactiveCareTeamWithOtherProviders =
            _.filter(sortedProvidersDict.inactiveCareTeamWithOtherProviders, function(p) {
                if (!p['physicianId']) { return true; }
                if (physician_ids.indexOf(p['physicianId']) === -1) {
                    physician_ids.push(p['physicianId']);
                    return true;
                } else {
                    return false;
                }
            });
            sortedProvidersDict.careTeamWithMainProviders.sort(that.careTeamSortFn);
            sortedProvidersDict.inactiveCareTeamWithOtherProviders.sort(that.careTeamSortFn);
        }

        destroyTooltips($patientTeam);
        $patientTeam.html(
            el8.template.appchart.providers.patientTeam(sortedProvidersDict)
        );

        if (el8Globals.FEATURES.PLR4Everyone) {
            if (sortedProvidersDict.careTeamProviders.activeMembers.length +
                sortedProvidersDict.careTeamProviders.inactiveMembers.length < 2) {
                $('.care-team-no-member-prompt', container).show();
            } else {
                $('.care-team-no-member-prompt', container).hide();
            }
        }
        postRenderFn($patientTeam);
    };

    // refresh a single provider entry in both tabs
    function refreshProvider(provider) {
        if (!provider) { return; }
        var $provider = $('.provider-entry[data-id="'+provider.getId()+'"]', $content);
        destroyTooltips($provider);
        delete clickTexts[provider.getId()];

        // there can be one match in each tab
        $provider.each(function(index, elt) {
            var $newProvider = $(el8.template.appchart.providers.providerEntry({
                provider: provider.asSoyMap(),
                collaboratorPractices: el8.ptdata.plrCollaborators.getPracticeIds()
            }));
            $(elt).replaceWith($newProvider);
            postRenderFn($newProvider);
        });
    }

    // Same pair of functions as below, but for care team
    // render the field, which doesn't exist yet and then init it
    function addInitCareTeamNotesField(providerId, $careTeamEntry) {
        var careTeamProvider = el8.ptdata.careTeamProviders.getById(providerId);
        $('.care-team-entry-note-section', $careTeamEntry).replaceWith($(
            el8.template.appchart.providers.careTeamProviderNoteSection({
                provider: careTeamProvider.asSoyMap()
            })
        ));
        var $elt = $('.care-team-entry-note-field', $careTeamEntry);
        clickTexts[providerId] = initCareTeamNoteField($elt, careTeamProvider);
    }
    // just init the field, which has already been rendered
    function initCareTeamNoteField($elt, careTeamProvider) {
        return (new el8.uiwidget.ClickText({
            maxLength: 300,
            changeFn: function(text) {
                careTeamProvider.saveProviderNote(text);
            }
        })).init({
            elt: $elt,
            initText: careTeamProvider.getNote()
        });
    }

    // render the field, which doesn't exist yet and then init it
    function addInitTreatmentReasonField(providerId, $providerEntry) {
        var provider = el8.ptdata.ptProviders.getById(providerId);
        $('.provider-entry-treating-section', $providerEntry).replaceWith($(
            el8.template.appchart.providers.treatmentReasonSection({
                provider: provider.asSoyMap()
            })
        ));
        var $elt = $('.provider-entry-treating-field', $providerEntry);
        clickTexts[providerId] = initTreatmentReasonField($elt, provider);
    }
    // just init the field, which has already been rendered
    function initTreatmentReasonField($elt, provider) {
        return (new el8.uiwidget.ClickText({
            maxLength: 300,
            changeFn: function(text) {
                provider.saveTreatmentReason(text);
            }
        })).init({
            elt: $elt,
            initText: provider.getTreatmentReason()
        });
    }

    return that;

})();
